module.exports = __webpack_public_path__ + "static/media/l12_voice_eight_v2.9a7ed3b8.mp3";